import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697aa5b8921dc9001404385d/crystalclean/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697aa5b8921dc9001404385d/crystalclean/src/app/customer-reviews/components/ReviewsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697aa5b8921dc9001404385d/crystalclean/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697aa5b8921dc9001404385d/crystalclean/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697aa5b8921dc9001404385d/crystalclean/src/components/ui/AppImage.tsx");
